export default {
    Info: 'info',
    Warning: 'warning'
}


// WEBPACK FOOTER //
// ./src/utils/constants/messageType.js